<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast />
                <h5>{{ $t('menu.shopOnlineTransactions') }}</h5>
                <div class="p-grid">
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Calendar ref="startDateCalendar" style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="startDateModel"></Calendar>
                            <label>{{ $t('sportsbets.startDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Calendar style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="endDateModel"></Calendar>
                            <label>{{ $t('sportsbets.endDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="shopsModel" :options="shops" optionLabel="name" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.shop') }}</label>
                        </span>
                    </div>
                    <div class="p-col-6 p-md-6 p-text-right"><Button type="button" :loading="isReportLoading" :label="$t('buttons.show')" class="p-button-raised p-button-success" @click="showReport()" /></div>
                    <transition-group name="p-message" tag="div" class="p-col-12">
                        <Message :key="errorKeyCount" :severity="'error'" v-show="showError">{{ $t('alerts.generalError') }}</Message>
                    </transition-group>
                </div>
                <div class="card" v-if="showReportData">
                    <DataTable :value="reportData" ref="datatable" responsiveLayout="scroll">
                        <Column>
                            <template #body="slotProps">
                                <span class="indexColumn">{{ slotProps.index + 1 }}</span>
                            </template>
                        </Column>
                        <Column :header="$t('system.shop')" field="ShopId" >
                            <template #body="slotProps"> {{ shopsDictionary[slotProps.data.ShopId] }}</template></Column
                        >
                        <Column field="Date" :header="$t('sportsbets.date')" :sortable="true">
                            <template #body="slotProps">{{ formatCSDateAndTime(slotProps.data.Date) }} </template>
                        </Column>
                        <Column field="Amount" :header="$t('bets.amount')" :sortable="true">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.Amount) }} </template>
                        </Column>
                        <Column :header="$t('transactions.type')" field="Type" :sortable="true">
                             <template #body="slotProps"> {{ slotProps.data.Type == 1 ? $t('transactions.deposit') : $t('transactions.withdrawal') }}</template>
                        </Column>
                        <Column :header="$t('bets.cashier')" field="CashierId" >
                         <template #body="slotProps"> {{ cashiersDictionary[slotProps.data.CashierId] }}</template>
                        </Column>
                        <Column :header="$t('transactions.id')" field="TransId" > </Column>
                        <Column :header="$t('general.status')" field="TransStatus"></Column>  
                        <Column :header="$t('transactions.error')" field="TransErrorMessage"> </Column>       

                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BoReportsApi } from '../../../service/BoReportsApi';
import { BoApi } from '../../../service/BoApi';
export default {
    name: 'report',
    data() {
        return {
            reportData: [],
            BoApi: new BoApi(),
            BoReportsApi: new BoReportsApi(),
            isReportLoading: false,
            showReportData: false,
            startDateModel: null,
            endDateModel: null,
            expenseDate: null,
            errorKeyCount: 0,
            showError: false,
            shops: [],
            shopsModel: { name: 'All', _id: 'all' },
            disableSubmit: false,
            crtRoute: 'shopExpenses',
            shopsDictionary: [],
             cashiersDictionary: [],
        };
    },
    mounted() {
        this.getShops();
        this.getCashierUsers();
        let crtDate = new Date();
        let year = crtDate.getFullYear();
        let month = crtDate.getMonth() + 1;
        if (month <= 9) {
            month = '0' + month;
        }
        let day = crtDate.getDate();
        if (day <= 9) {
            day = '0' + day;
        }
        var startDateString = year + '-' + month + '-' + day + 'T00:00';
        var endDateString = year + '-' + month + '-' + day + 'T23:59';
        this.startDateModel = new Date(startDateString);
        this.endDateModel = new Date(endDateString);    
        this.showReport();
    },
    computed: {
        editPage() {
            return this.crtRoute + '/add';
        },
        availableMenus() {
            return this.$store.getters['user/availableMenus'];
        },
    },
    watch: {
        shopsModel() {
            if (!this.notNullOrEmptyObject(this.shopsModel)) {
                this.shopsModel = { name: 'All', _id: 'all' };
            }
            this.showReport();
        },
    },
    methods: {
        getShops() {
            this.BoApi.getShops('')
                .then((shopsResponse) => {
                    let shopsDdlValues = [];
                    for (var i = 0; i < shopsResponse.data.length; i++) {
                        let shopItem = {
                            name: shopsResponse.data[i].code + ' - ' + shopsResponse.data[i].name,
                            code: shopsResponse.data[i].code,
                            _id: shopsResponse.data[i]._id,
                        };
                        shopsDdlValues.push(shopItem);
                    }
                    this.shops = shopsDdlValues;
                    this.createShopsDictionary();
                    this.shops.unshift(this.shopsModel);
                    if( this.notNullOrEmptyObject( this.$route.params.shopId))
                    {
                        this.shopsModel = this.shops.find(shop => shop._id == this.$route.params.shopId)
                    }
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                });
        },
        getCashierUsers() {
            this.BoApi.getAllUsers()
                .then((userResponse) => {
                    this.users = userResponse.data;
                    this.createcashiersDictionary();
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                });
        },
        showReport() {
            this.showReportData = false;
            this.isReportLoading = true;
            this.BoReportsApi.shopsOnlineTransactionsReport( this.formatEnDateAndTime(this.startDateModel),
                                                    this.formatEnDateAndTime(this.endDateModel),
                                                    this.shopsModel._id)
                .then((reportResponse) => {
                    if (reportResponse.data != null) {
                        this.reportData = reportResponse.data;
                        this.tableKey++;
                    }
                    this.isReportLoading = false;
                    this.showReportData = true;
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                    this.showError = true;
                    this.errorKeyCount++;
                    this.isReportLoading = false;
                });
        },
        createShopsDictionary() {
            for (let i = 0; i < this.shops.length; i++) {
                this.shopsDictionary[this.shops[i]._id] = this.shops[i].code + ' - ' + this.shops[i].name;
            }
        },
        createcashiersDictionary() {
            for (let i = 0; i < this.users.length; i++) {
                this.cashiersDictionary[this.users[i]._id] = this.users[i].username;
            }
        },
    },
};
</script>